import styled from 'styled-components'

import { flexCol } from '~/shared/styles/layout'

export const Wrapper = styled.div`
  ${flexCol}
  align-items: flex-start;
  padding: 8px 0px;
  width: 100%;
  user-select: none;

  & > * {
    max-width: 100%;
    max-height: 40vh;
    user-select: none;
    border-radius: 18px;
  }
`
